<ng-content></ng-content>

<mat-icon *ngIf="tooltip" [matTooltip]="tooltip" (click)="$event.stopPropagation()" data-html2canvas-ignore>
  info_outline
</mat-icon>
